if (!customElements.get('pdp-mediagrid')) {
  customElements.define(
    'pdp-mediagrid',
    class PdpMediagrid extends HTMLElement {
      constructor() {
        super()
        this.videoBtns = this.querySelectorAll('[data-play-btn]')
        this.videoBtns.forEach((videoBtn) => {
          videoBtn.addEventListener('click', (e) => {
            const parent = e.target.closest('[data-media-wrapper]')
            const videoHtml = parent.querySelector('[data-video-html]').innerHTML
            openPuffcoModal(videoHtml, true)
          })
        })
      }
    },
  )
}
